import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Payments from '../../Common/Payment';

class Payment extends Component {

  render() {
    const { pyme } = this.props;

    const quoterData = {
      CoveragePlan: pyme.coveragePlan,
      CoverageModule: pyme.coverageModule
    };

    return (
      <div>
        <Payments
          currency='USD'
          quoterData={quoterData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    pyme: state.pyme,
  };
};

export default connect(mapStateToProps, null)(Payment);